var Shortcut=function(shortcut){return shortcut};export{Shortcut};
//# sourceMappingURL=shortcuts.js.map
